import { Box } from "@mui/material";

export default function TutorialModeLayer() {
  return (
    <Box
      sx={{ position: "fixed", top: 0, right: 0, bottom: 0, left: 0, background: "rgba(0, 0, 0, 0.65)", zIndex: 4 }}
    ></Box>
  );
}
